"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const vueRoot_1 = require("@/client/components/vueRoot");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'OverviewSettings',
    methods: {
        toggleTagsView() {
            (0, vueRoot_1.vueRoot)(this).setVisibilityState('tags_concise', !(0, vueRoot_1.vueRoot)(this).getVisibilityState('tags_concise'));
        },
        getTagToggleLabel() {
            return (0, vueRoot_1.vueRoot)(this).componentsVisibility['tags_concise'] ? 'full' : 'concise';
        },
    },
});
